import { NavLink, Outlet } from 'react-router-dom';
import { isDue } from '../lib/cards';
import { useClassroom } from '../state/Classroom';
import { GameInvite } from '../routes/student/ClassGamePlay';
import BugReportTab from './BugReport';
import { inStudentView, leaveStudentView } from '../lib/studentView';
import { connectExtension } from '../lib/extension';
import { useEffect } from 'react';

/** The student shell. Teachers get components/TeacherLayout.tsx. */
export default function Layout() {
  const { classrooms, active, setActiveId, student, cards, session } = useClassroom();
  // The Chrome extension signs in as this student by itself (no typing): see lib/extension.ts.
  const uid = session?.user.id;
  useEffect(() => { void connectExtension(uid); }, [uid]);
  const due = cards.filter(c => isDue(c)).length;
  const link = ({ isActive }: { isActive: boolean }) => (isActive ? 'active' : '');

  return (
    <div className="shell">
      {inStudentView() && (
        <div className="student-view-bar" role="status">
          <span>👀 <strong>Student view</strong>: this is what your students see. What you do here isn’t in your results.</span>
          <button type="button" className="small" onClick={() => void leaveStudentView()}>← Back to teacher</button>
        </div>
      )}
      <header className="topbar">
        <NavLink to="/" className="brand">🐠 Gibberfish <span className="brand-sub">Classroom</span></NavLink>

        {classrooms.length > 1 && (
          <select
            aria-label="Class"
            style={{ width: 'auto' }}
            value={active?.id ?? ''}
            onChange={e => setActiveId(e.target.value)}
          >
            {classrooms.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
        )}

        <nav className="nav">
          <NavLink to="/" end className={link}>Home</NavLink>
          <NavLink to="/video" className={link}>Video</NavLink>
          <NavLink to="/story" className={link}>Story</NavLink>
          <NavLink to="/grammar" className={link}>Grammar</NavLink>
          <NavLink to="/cards" className={link}>
            Flashcards {due > 0 && <span className="count">{due}</span>}
          </NavLink>
          <NavLink to="/vocab" className={link}>Vocabulary</NavLink>
          <NavLink to="/ocean" className={link}>Ocean</NavLink>
          <NavLink to="/shop" className={link}>Shop</NavLink>
          <NavLink to="/work" className={link}>All work</NavLink>
          <NavLink to="/account" className={link}>{student ? student.username : 'Account'}</NavLink>
        </nav>
      </header>

      <main className="page"><Outlet /></main>
      {active && <GameInvite />}
      {active && <BugReportTab />}
    </div>
  );
}
